// extracted by mini-css-extract-plugin
export var clientReviews = "Home-module--clientReviews--9f37f";
export var clientReviewsSlide = "Home-module--clientReviews__slide--820a0";
export var clientReviewsSlideBody = "Home-module--clientReviews__slide__body--1c403";
export var clientReviewsSlideBodyStats = "Home-module--clientReviews__slide__body__stats--3b1b0";
export var clientReviewsSlideHeader = "Home-module--clientReviews__slide__header--19518";
export var clientReviewsSlideHeaderImg = "Home-module--clientReviews__slide__header__img--c11b3";
export var clientReviewsSlideHeaderImgActive = "Home-module--clientReviews__slide__header__img__active--21e71";
export var clientReviewsSlideHeaderTitle = "Home-module--clientReviews__slide__header__title--df4e2";
export var clients = "Home-module--clients--c118f";
export var clientsHeader = "Home-module--clients__header--fe0f2";
export var clientsRow = "Home-module--clients__row--1d72c";
export var grids = "Home-module--grids--dd765";
export var hero = "Home-module--hero--cbd38";
export var home = "Home-module--home--29314";
export var mobile = "Home-module--mobile--9dd36";
export var paragraph = "Home-module--paragraph--6e430";
export var paragraphSm = "Home-module--paragraph-sm--bbe54";
export var paragraphXs = "Home-module--paragraph-xs--d0738";
export var productCards = "Home-module--productCards--a8a87";
export var productCardsGrid = "Home-module--productCards__grid--19b9d";
export var titleH1 = "Home-module--title-h1--2c534";
export var titleH1Alt = "Home-module--title-h1--alt--06733";
export var titleH2 = "Home-module--title-h2--980d8";
export var titleH2Alt = "Home-module--title-h2--alt--8fdfc";
export var titleH3 = "Home-module--title-h3--378c9";
export var titleH3Alt = "Home-module--title-h3--alt--0d50a";
export var titleH4 = "Home-module--title-h4--25df7";
export var titleH4Alt = "Home-module--title-h4--alt--a8c12";
export var titleH5 = "Home-module--title-h5--148db";
export var video = "Home-module--video--13ea4";
export var videoContainer = "Home-module--video__container--49b73";